/**
 * Service: helpers
 */
angular.module('acme.common.service.helpers', [
  'acme.common.service.utils'
])
.service('HelpersService', ['UtilsService', '$location', '$q', function(UtilsService, $location, $q) {

    return {

      utils: UtilsService,
      errors: [],

      fieldTypes: [
        'NumberType',
        'NumberArrayType',
        'StringType',
        'StringArrayType',
        'RangeType'
      ],

      dateFormats: {
        tinyDate: 'M/d',
        shortDate: 'M/d/yy',
        shortDateAlt: 'MM/DD/YY',
        shortDateTime: 'M/d/yy \'at\' h:mm a',
        midDate: 'M/d/yyyy',
        midDateAlt: 'M/d/YYYY',
        standardDate: 'MMM d, yyyy',
        standardDateAlt: 'MMM D, YYYY',
        standardTime: 'h:mm a',
        militaryTime: 'HH:mm',
        standardDateTime: 'MMM d, yyyy \'at\' h:mm a',
        mediumDate: 'EEEE, MMMM d',
        extendedDate: 'EEEE, MMMM d, yyyy',
        extendedDateTime: 'EEEE, MMMM d, yyyy \'at\' h:mm a',
        sortDate: 'yyyy-M-d',
        sortDateTime: 'yyyy-M-d \'at\' h:mm a',
        sortDateAlt: 'yyyy/M/d',
        sortDateAlt2: 'YYYY-M-d',
        sortDateTimeAlt: 'yyyy/M/d \'at\' h:mm a',
        fieldDate: 'yyyy-MM-dd',
        ccExpirationDate: 'MM/YYYY',
        ccExpirationDateAlt: 'MM/yyyy',
        longYear: 'yyyy',
        shortYear: '\'yy',
        month: 'MMMM yyyy',
        day: 'dddd, MMM d, yyyy',
        fullCalendarTime: 'h:mmtt',
        week: "'MMM d[ yyyy]{ '&#8212;'[ MMM] d yyyy}'",
        ISO8601: 'yyyy-MM-ddTHH:mm:ssZ',
        momentISO8601: 'YYYY-MM-DDTHH:mm:ssZZ'
      },

      init: function() {
        return true;
      },


      /**
       * Formats a date by the provided argument
       * @param {Date|String} date - the date to be formatted
       * @param {String} date - a moment format
       * @returns {String} - formatted date
       */
      formatDate: function(date, format) {
        return moment(date).format(format);
      },


      /**
       * Calculate contrast based on hex
       * @source https://24ways.org/2010/calculating-color-contrast/
       * @author Brian Suda <http://suda.co.uk>
       * @param hexcolor
       * @returns {string}
       */
      getContrastYIQ: function(hexcolor) {

        var r, g, b,
            yiq,
            hex,
            shex;

        if  (/^#/.test(hexcolor)) {
          shex = hexcolor.split('');
          shex.shift();
          hex = shex.join('');
        }

        r = parseInt(hex.substr(0,2),16);
        g = parseInt(hex.substr(2,2),16);
        b = parseInt(hex.substr(4,2),16);

        yiq = ((r*299)+(g*587)+(b*114))/1000;

        return (yiq >= 128) ? '#000000' : '#ffffff';

      },

      /**
       * Convert a string to array based on delimiter
       *
       * @param value {String}
       * @param delimiter {String}
       * @returns {Array}
       */
      stringToArray: function(value, delimiter) {

        var a = [],
            delim = delimiter || ',';

        if (typeof(value) === 'string' && value.length > 0) {
          a = value.split(delim);
        }

        return a;

      },

      /**
       * Convert string or number to an integer value
       *
       * @param value {String | Number}
       * @param significant {Number} significant digits
       */
      currencyFloatToInteger: function(value, significant) {

        var r = 0,
            round = 0,
            digit = 0,
            sigs = (significant) ? significant : 2,
            decimal = 0;

        if (typeof(value) === 'string') {
          r = parseFloat(value);
        }else if (typeof(value) === 'number') {
          r = value;
        }

        if (isNaN(r)) {
          r = 0;
        }else {
          decimal = r * Math.pow(10, sigs);
          r = parseInt(decimal, 10);
          round = decimal.toString().split('.')[1];
          if (round) {
            digit = parseInt(round.charAt(0), 10);
            if (parseInt(digit, 10) >= 5) {
              r += 1;
            }
          }
        }

        return r;

      },

      /**
       * Convert string or number to an integer value with significant digits
       *
       * @param value {Integer}
       * @param significant {Integer}
       *
       */
      integerToCurrencyFloat: function(value, significant, enforceFixed) {

        var r = 0,
            round = 0,
            digit = 0,
            sigs = (significant) ? significant : 2,
            decimal = 0;

        if (typeof(value) === 'number') {
          r = value;
        }

        if (isNaN(r)) {
          r = 0;
        }else {
          decimal = r / Math.pow(10, sigs);
          r = decimal;
          round = decimal.toString().split('.')[1];
          if (round && round.length > 2) {
            digit = parseInt(round.charAt(2), 10);
            if (parseInt(digit, 10) >= 5) {
              r += 1;
            }
          }
        }

        if (enforceFixed) {
          r = r.toFixed(2);
        }

        return r;

      },

      /**
       * Converter for variable format date strings
       *
       * @param value {String}
       */
      convertDate: function(value) {
        return moment(value).format(this.dateFormats.fieldDate.toUpperCase());
      },
      
      /**
       * Validates date in ISO_8601 format
       *
       * @param value {String}
       * @return {Boolean}
       */
      validISODate: function (value) {
        return moment(value, moment.ISO_8601, true).isValid();
      },

      /**
       * Validates whether passed JSON is valid
       * @param json
       * @returns {boolean}
       */
      validJson: function(json) {
        var isValid = true;

        try {
          JSON.parse(json);
        } catch(e) {
          isValid = false;
        }

        return isValid;
      },

      /**
       *
       * Extends an object
       *
       * @param a {Object}
       * @param b {Object}
       */
      decorate: function(a, b) {
        return $.extend(a, b);
      },

      /**
       * Capitalize
       *
       * @param s {String}
       * @returns {string}
       */
      cap: function(s) {
        return (s) ? s.charAt(0).toUpperCase() + s.slice(1) : '';
      },

      /**
       * lowCapitalize
       *
       * @param s {String}
       */
      low: function(s) {
        return (s) ? s.charAt(0).toLowerCase() + s.slice(1) : '';
      },
      
      /**
       * Capitalize first char turn everything else to lowercase
       *
       * @param s {String}
       */
      capFirstLetter: function (s) {
        return (!!s) ? s.charAt(0).toUpperCase() + s.substr(1).toLowerCase() : '';
      },

      /**
       * split camel case strings into spaced strings
       *
       * @param s
       * @returns {string}
       */
      camelCaseSplit: function(s) {

          var re, match, output = [];
          // re = /[A-Z]?[a-z]+/g
          re = /([A-Za-z]?)([a-z]+)/g;

          /*
           matches example: "oneTwoThree"
           ["one", "o", "ne"]
           ["Two", "T", "wo"]
           ["Three", "T", "hree"]
           */

          match = re.exec(s);
          while (match) {
            // output.push(match.join(""));
            output.push([match[1].toUpperCase(), match[2]].join(""));
            match = re.exec(s);
          }

          return output;

      },

      /**
       * @param {T[]} values
       * @returns {T[]}
       */
      uniq: function (values) {
        var result = [];

        for (var index = 0; index < values.length; index++) {
          var item = values[index];
          
          if (result.indexOf(item) === -1) {
            result.push(item);
          }
        }

        return result;
      },

      /**
       * Merges two arrays uniquely
       *
       * @param a {Array}
       * @param b {Array}
       * @returns {*}
       */
      unique: function(a, b) {
        var i, ii,
            _a = [],
            _b = [];

        if (a) {
          if (!(a instanceof Array)) {
            _a = [a];
          } else if (a instanceof Array) {
            _a = a;
          }
        }

        if (b) {
          if (!(b instanceof Array)) {
            _b = [b];
          }else if (b instanceof Array) {
            _b = b;
          }
        }

        for (i=0,ii=_b.length;i<ii;i++) {
          if (_a.indexOf(_b[i]) === -1) {
           _a.push(_b[i]);
          }
        }

        return _a;

      },

      /**
       * Strip HTML from text
       *
       * @param text
       * @param limit
       * @returns {string}
       */
      strip: function(text, limit) {
        var r = '';

        if (text) {
          r = String(text).replace(/<[^>]+>|(?!<br>)(?!&nbsp;)(?!&amp;)&.*?;/gm, '');

          r = r.replace(/<br>/gm, ' ');
          r = r.replace(/&amp;/gm, '&');
          r = r.replace(/&nbsp;/gm, ' ');

          if (limit && r.length > limit) {
            r = r.substring(0, limit - 2) + '...';
          }
        }

        return r;
      },

      /**
       * check if object is empty
       *
       * @param object
       * @returns {bool}
       */
      isEmptyObject: function(obj) {
        var r = true, key;
        if (obj) {
          for(key in obj) {
            if(obj.hasOwnProperty(key)) {
              r = false;
              break;
            }
          }
        }
        return r;
      },

      /**
       * Replaces incorrect originalPath from uploaded images with correct path
       *
       * @param path
       * @returns {String}
       */
      correctORImage: function(path) {
        var r,
            regex = new RegExp(/(.*)\/(.*?)_OR\.(png|jpg|gif|jpeg|tiff|bmp)$/);


        if (regex.test(path)) {
          r = path.replace(regex, "$1/_OR_$2.$3");
        }else{
          r = path;
        }

        return r;
      },

      getPaginator: function(props) {

        var r = {
              page: 1,
              pageSize: -1,
              sortDirection: "asc",
              sortField: "name"
            };

        if (props) {
          r.page = props.page || 1;
          r.pageSize = props.pageSize || -1;
          r.sortDirection = props.sortDirection || "asc";
          r.sortField = props.sortField || "name";
        }

        return r;

      },

      getEntityEmptyImage: function(type) {
        var uuid;

        switch(type) {
          case 'facilities':
            uuid = '5afa7c3a-e2ea-4d73-8d53-0e0788a84076';
            break;
          case 'personnel':
            uuid = '09728cd8-2be9-4966-8ca3-7cfe0ef9e5c9';
            break;
          case 'equipment':
            uuid = '21583c37-a424-4f27-b3b6-fdc3bdb437bc';
            break;
        }

        return '/v2/api/photos/' + uuid + '/PM';
      },

      getEntityName: function(type) {

        var entityName = {
              singular: '',
              plural: ''
            };

        if (type) {
          switch (type.toLowerCase()) {
            case 'personnel':
              entityName.singular = type;
              entityName.plural = type;
              entityName.displaySingular = 'person';
              entityName.displayPlural = 'people';
              break;
            case 'equipment':
              entityName.singular = type;
              entityName.plural = type;
              entityName.displaySingular = 'equipment';
              entityName.displayPlural = 'equipment';
              break;
            case 'facilities':
              entityName.singular = 'facility';
              entityName.plural = type;
              entityName.displaySingular = 'place';
              entityName.displayPlural = 'places';
              break;
          }
        }

        return entityName;

      },

      /** Return length of input strings **/
      getTextLength: function(text) {
        var r = 0,
            _text = '';

        if (text && typeof(text) === 'string') {
          _text = text.replace(/[\s\n]/g,' ');
          r = _text.length;
        }

        return r;
      },

      /**
       * Return suffixed numeric value
       *
       * @param n {Number}
       * @param suffixOnly {boolean}
       * @returns {string}
       */
      getEth: function(n, suffixOnly) {
        var suffix = '',
          s = n.toString(),
          fullNum = parseInt(n, 10),
          num = parseInt(s.substr(-1), 10);

        switch(num) {
          case 1:
            suffix = 'st';
            break;
          case 2:
            suffix = 'nd';
            break;
          case 3:
            suffix = 'rd';
            break;
          default:
            suffix = 'th';
        }

        if (fullNum === 11 || fullNum === 12 || fullNum === 13) {
          suffix = 'th';
        }

        if (fullNum === 0) {
          suffix = '';
        }

        return (suffixOnly) ? suffix : s + suffix;
      },

      /**
       * Wrapper for $.cookie(...);
       *
       * @param name
       * @returns {Object}
       */
      getCookie: function(name) {
        // Using JQuery
        var cookie = $.cookie(name);

        if (cookie && cookie.match(/^\{/)) {
          cookie = angular.fromJson(cookie);
        }

        return cookie;
      },

      /**
       * Wrapper for $.cookie(...);
       *
       * @param name
       * @param value
       */
      setCookie: function(name, value) {
        // Using JQuery
        $.cookie(name, angular.toJson(value), {
          expires: 1,
          path: '/'
        });
      },

      /**
       * Wrapper for $.removeCookie(...);
       *
       * @param name
       */
      killCookie: function(name) {
        // Using JQuery
        return $.removeCookie(name, {
          path: '/'
        });
      },

      /**
       *  http://stackoverflow.com/questions/512528/set-cursor-position-in-html-textbox
       */
      setCaretPosition: function (elem, caretPos) {

        if(elem != null) {
          if(elem.createTextRange) {
            var range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
          }
          else {
            if(elem.selectionStart) {
              elem.focus();
              elem.setSelectionRange(caretPos, caretPos);
            } else {
              elem.focus();
            }
          }
        }
      },

      /**
       *  Returns the caret (cursor) position of the specified text field.
       *  Return value range is 0-oField.value.length.
       *  http://stackoverflow.com/questions/2897155/get-cursor-position-in-characters-within-a-text-input-field
       */
      getCaretPosition: function(oField) {

        // Initialize
        var iCaretPos = 0;

        // IE Support
        if (document.selection) {

          // Set focus on the element
          oField.focus();

          // To get cursor position, get empty selection range
          var oSel = document.selection.createRange();

          // Move selection start to 0 position
          oSel.moveStart('character', -oField.value.length);

          // The caret position is selection length
          iCaretPos = oSel.text.length;
        } else if (oField.selectionStart || oField.selectionStart == '0') {
          // Firefox support
          iCaretPos = oField.selectionStart;
        }

        // Return results
        return iCaretPos;

      },


      /**
       * Select and scroll to a specific line within a `textarea`
       *
       * via https://stackoverflow.com/a/13651036/142714
       * @param textarea - textarea element reference
       * @param lineNum - line number
       * @returns {boolean}
       */
      selectAndScrollToTextareaLine: function (textarea, lineNum) {
        lineNum--; // array starts at 0
        var lines = textarea.value.split("\n");
        var lineHeight = parseInt($(textarea).css('line-height'), 10);

        // Calculate start / end
        var startPos = 0, endPos = textarea.value.length;
        for(var x = 0; x < lines.length; x++) {
          if(x === lineNum) {
            break;
          }
          startPos += (lines[x].length+1);
        }

        endPos = lines[lineNum].length + startPos;

        // Do selection:

        // Chrome / Firefox
        if(typeof(textarea.selectionStart) !== 'undefined') {
          textarea.focus();
          textarea.selectionStart = startPos;
          textarea.selectionEnd = endPos;

          // Navigate:
          textarea.scrollTop = lineNum * lineHeight;

          return true;
        }

        // IE
        if (document.selection && document.selection.createRange) {
          textarea.focus();
          textarea.select();

          var range = document.selection.createRange();
          range.collapse(true);
          range.moveEnd("character", endPos);
          range.moveStart("character", startPos);
          range.select();

          // Navigate:
          textarea.scrollTop = lineNum * lineHeight;

          return true;
        }

        return false;
      },

      /**
       * Gets the value of a field based on its type
       * An optional stringify value can be passed
       *
       * Accepts:
       * {
       *   fieldOrder: {Number}
       *   name: {String}
       *   type: {String}
       *   stringValue: {String},
       *   stringArrayValue: {Array},
       *   minValue: {Number},
       *   maxValue: {Number},
       *   hidden: {boolean}
       * }
       *
       * @param field {Object}
       * @param (optional) stringify {Object}
       * @returns {boolean}
       */
      getFieldValue: function(field, stringify) {

        var r,
            fieldKey;

        if (field.hasOwnProperty('type')) {
          fieldKey = this.low(field.type.replace('Type', 'Value'));
          if (field[fieldKey]) {
            if (fieldKey.indexOf('Array') > 0 && stringify) {
              r = field[fieldKey].join(',');
            } else {
              r = field[fieldKey];
            }
          }
        }

        return r;

      },



      getFieldValueAsStrings: function(field) {

        var r,
          fieldKey;

        if (field.hasOwnProperty('type')) {
          fieldKey = this.low(field.type.replace('Type', 'Value'));
          if (field[fieldKey]) {
            if (fieldKey.indexOf('Array') > 0) {
              r = $.each(field[fieldKey], function(index, value) {
                return value.toString();
              });
            } else {
              r = field[fieldKey];
            }
          }
        }

        return r;

      },


      /**
       * Gets field type and simpleType
       * Returns false if it can't be found
       *
       * Accepts:
       * {
       *   fieldOrder: {Number}
       *   name: {String}
       *   type: {String}
       *   stringValue: {String},
       *   stringArrayValue: {Array},
       *   minValue: {Number},
       *   maxValue: {Number},
       *   hidden: {boolean}
       * }
       *
       * @param field {Object}
       * @returns {boolean}
       */
      getFieldType: function(field) {

        var r = false;

        if (field.hasOwnProperty('type')) {
          r  = {
            type: field.type,
            simpleType: this.low(field.type.replace('Type', '').replace('Array', ''))
          };
        }

        return r;

      },

      /**
       * Removes non-selected type value from field
       * Returns field object
       *
       * Accepts:
       * {
       *   fieldOrder: {Number}
       *   name: {String}
       *   type: {String}
       *   stringValue: {String},
       *   stringArrayValue: {Array},
       *   minValue: {Number},
       *   maxValue: {Number},
       *   hidden: {boolean}
       * }
       *
       * @param field
       * @returns {*}
       */
      clearFieldValues: function(field) {

        var i, ii,
            fieldKey;

        for (i=0,ii=this.fieldTypes[i].length;i<ii;i++) {
          if (field.type && field.type !== this.fieldTypes[i]) {
            fieldKey = this.low(field.type.replace('Type', 'Value'));
            field[fieldKey] = null;
          }
        }

        return field;

      },      
      /**
       * Returns one of the following value types:
       *
       * - NumberType, NumberArrayType
       * - StringType, StringArrayType
       * - RangeType
       *
       * @param type {String}
       * @param value {String|Array}
       * @returns {*}
       */
      parseValueType: function(type, value, allowEmptyValues) {

        var i, ii,
            r = false,
            result,
            valueType,
            valueSimpleType,
            errorMessage,
            keyType,
            range,
            rangeDefault,
            rangeDelim = '-',
            arrayDelim = ',',
            isArray = /\,/g.test(value);

        if (value) {

          switch (type) {
            case 'number':
              valueSimpleType = type;

              if (isArray) {
                if (value instanceof Array) {
                  r = value;
                }else {
                  r = value.split(arrayDelim);
                }
                for (i=0,ii= r.length;i<ii;i++) {
                  if (isNaN(r[i])) {
                    r = false;
                    errorMessage = 'Only numeric values allowed';
                    break;
                  }else{
                    r[i] = parseInt(r[i], 10);
                  }
                }
              } else {
                if (!isNaN(value)) {
                  r = parseInt(value, 10);
                }else{
                  errorMessage = 'Only numeric values allowed';
                }
              }
              break;
            case 'string':
              valueSimpleType = type;

              if (isArray) {
                if (value instanceof Array) {
                  r = value;
                }else {
                  r = value.split(arrayDelim);
                }
                for (i=0,ii= r.length;i<ii;i++) {
                  // Kill whitespace
                  if (typeof(r[i]) === 'string') {
                    r[i] = r[i].replace(/^\s*([\w\s.]*)\s*$/, "$1");
                  }
                }
              }else{
                r = value;
              }
              break;
            case 'range':
              valueSimpleType = type;

              // Range should be passed as 1-20[,3]
              // 1-20 is the range
              // 3 is an optional default value
              if (isArray) {
                rangeDefault = value.split(arrayDelim)[1];
                range = value.split(arrayDelim)[0].split(rangeDelim);
              }else{
                range = value.split(rangeDelim);
                rangeDefault = range[0];
              }
              // Since there is no RangeArrayType
              // isArray should be false so we'll override it
              isArray = false;

              // Ensure all values are numeric
              if (isNaN(range[0]) || isNaN(range[1]) || isNaN(rangeDefault)) {
                r = false;
                errorMessage = 'Only numeric values allowed';
                break;
              }
              // Ensure there are exactly 2 values for min and max
              if (range.length === 2) {
                r = {
                  rangeValue: parseInt(rangeDefault, 10),
                  rangeMinValue: parseInt(range[0], 10),
                  rangeMaxValue: parseInt(range[1], 10)
                };
              }else{
                errorMessage = 'Invalid range';
                r = false;
              }
              break;
            default:
              errorMessage = 'Invalid type';
              r = false;
          }

        }else if (!value && allowEmptyValues) {
          switch(type) {
            case 'number':
              /* Falls through */
            case 'string':
              /* Falls through */
            case 'range':
              valueSimpleType = type;
              r = null;
              break;
            default:
              errorMessage = 'Invalid type';
              r = false;
          }
        }else{
          errorMessage = 'No Value';
        }

        if (r !== false) {

          valueType = this.cap(type);
          valueType += (isArray) ? 'Array' : '';
          valueType += 'Type';

          keyType = type;
          keyType += (isArray) ? 'Array' : '';
          keyType += 'Value';

          result = {
            type: valueType,
            key: keyType,
            simpleType: valueSimpleType,
            value: r
          };

        }else{
          this.errors = [{
            message: errorMessage
          }];

          result = r;
        }

        return result;

      },

      getCustomFieldValue: function(item, name) {
        var r = '',
          i, ii;
        if (item &&
          item.hasOwnProperty('customFields') && item.customFields instanceof Array &&
          name) {
          for (i=0, ii=item.customFields.length; i < ii; i++) {
            if (item.customFields[i] && item.customFields[i].hasOwnProperty('name') && item.customFields[i].name === name) {
              r = item.customFields[i].value;
              break;
            }
          }
        }
        return r;
      },

      /**
       * Converts months into years/months readable string
       *
       * @param int
       * @returns {String}
       */
      getFormattedDuration: function(durationInMonths) {
        var r = '',
          years = 0,
          months = 0;

        if (durationInMonths && !isNaN(parseInt(durationInMonths, 10))) {

          if (durationInMonths >= 12) {
            years = parseInt(durationInMonths / 12, 10);
            months = parseInt(durationInMonths % 12, 10);
          } else {
            months = durationInMonths;
          }

          if(years) {
            r = years + ((years === 1) ? ' Year' : ' Years');
          }
          if(months) {
            r += (r ? ', ': '') + (months + ((months === 1) ? ' Month' : ' Months'));
          }

        }

        return r;
      },

      getName: function (data) {
        var name = '';

        if (data) {
          if (data.firstName != null && data.firstName !== '') {
            name = data.firstName;
          } else if (data.name && data.name !== '') {
            name = data.name;
          } else if (data.email && data.email !== '') {
            name = data.email;
          }
        }

        return name;
      },

      getFullName: function(data) {
        var fullName = '';

        if (data) {
          if (data.firstName != null &&
            data.lastName != null &&
            data.firstName !== '' &&
            data.lastName !== '') {
            fullName = data.firstName + " " + data.lastName;
          } else if (data.name && data.name !== '') {
            fullName = data.name;
          } else if (data.email && data.email !== '') {
            fullName = data.email;
          }
        }

        return fullName;
      },

      isProd: function() {
        return ($location.host() === 'backoffice.acmeticketing.com');
      },
      
      /**
       * Creates an object composed of keys generated from running each element of an array through a predicateFn
       * @param {Array} values 
       * @param {(any) => string|number} predicateFn 
       */
      keyBy: function(values, predicateFn) {
        values = values || [];

        return values.reduce(function(acc, item, index) {
          var key = predicateFn(item, index);
          var collection = Object.assign({}, acc);
          collection[key] = item;

          return collection;
        }, {});
      },
      
      /**
       * Creates an entities object with an array of ids and a dictionary of entities
       * @param {Array} values 
       * @param {(any) => string|number} predicateFn 
       */
      createEntityState: function(values, predicateFn) {
        values = values || [];
        var ids = values.map(predicateFn);
        var entities = this.keyBy(values, predicateFn);

        return { ids: ids, entities: entities };
      },

      /**
       * Retrieve the value at a given path. Otherwise returns the provided default value
       * 
       * @param {Object} nestedObj
       * @param {Array<string|number>} path
       * @param {any} [defaultValue]
       * 
       * @returns {any}
       */
      path: function(nestedObj, path, defaultValue) {
        var value = path.reduce(function (obj, key) {
          return (obj && obj[key] !== 'undefined') ? obj[key] : undefined;
        }, nestedObj);
        
        return value == null ? defaultValue : value;
      },

      /**
       * Returns a number whose value is always within a given range
       * 
       * @param {number} value
       * @param {number} min
       * @param {number} max
       */
      clamp: function(value, min, max) {
        return Math.min(Math.max(value, min), max);
      },

      /**
       * Coerces a value to a boolean
       * @param {string | boolean | null | undefined} value Allowed values for a boolean input
       * @returns {boolean}
       */
       coerceBooleanProperty: function (value) {
        return value != null && String(value) !== 'false';
      },

      /**
       * Concat an array and validates the values exist
       * @param {array} words 
       * @param {string} glue 
       * @returns {string}
       */
      arrayConcat: function(words, glue) {
        return words
        .reduce(function(prev, current) {
          return (current) ? prev + current + glue : prev;
        }, '')
        .trim();
      },

      /**
       * Coerces a value to an array
       * @param {T} maybeArray
       * @returns {Array<T>}
       * @deprecated Use `coerceArray` from ui/src/app/common/utils/coerce-array.ts
       */
       coerceArray: function (maybeArray) {
        return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
      },

      /**
       * 
       * @param {Promise<T>[]} promises
       * @param {<R>(value: R) => boolean} predicateFn
       * @returns {Promise<boolean>}
       */
      somePromise: function (promises, predicateFn) {
        var q = $q.defer();
        var resolveCount = 0;

        var resolved = function (value) {
          if (predicateFn(value)) {
            q.resolve(true);
          } else if (++resolveCount === promises.length) {
            q.resolve(false);
          }
        };
        
        var rejected = function (value) {
          q.resolve(false);
        };

        for (var index = 0; index < promises.length; index++) {
          var promise = promises[index];
          promise.then(resolved, rejected);
        }

        return q.promise;
      },

      /**
       * Moves an item one index in an array to another.
       * @param {T[]} array Array in which to move the item.
       * @param {number} fromIndex Starting index of the item.
       * @param {number} toIndex Index to which the item should be moved.
       */
      moveItemInArray: function (array, fromIndex, toIndex) {
        var from = this.clamp(fromIndex, 0, array.length - 1);
        var to = this.clamp(toIndex, 0, array.length - 1);

        if (from === to) {
          return;
        }

        var target = array[from];
        var delta = to < from ? -1 : 1;

        for (var i = from; i !== to; i += delta) {
          array[i] = array[i + delta];
        }

        array[to] = target;
      }
    };
  },
]);
